/**
 * Apply the active preset CSS variables onto booking roots.
 * PHP also outputs these via <style> and inline style; this runs if CSS load
 * order blocks inheritance, and again after each wizard re-render.
 */
const ROOT_SELECTOR =
	'#bookpress-booking-root, #bookpress-service-selector, #bookpress-staff-selector, #bookpress-manage-booking-root, .bookpress-booking-root, .bookpress-service-selector, .bookpress-staff-selector, .bookpress-manage-booking-root';

export function applyThemeVars(theme) {
	if (!theme || typeof theme !== 'object') {
		return;
	}

	const entries = Object.entries(theme).filter(([name, value]) => name && value);

	if (!entries.length) {
		return;
	}

	document.querySelectorAll(ROOT_SELECTOR).forEach((root) => {
		entries.forEach(([name, value]) => {
			try {
				root.style.setProperty(name, String(value), 'important');
			} catch (err) {
				root.style.setProperty(name, String(value));
			}
		});
	});
}
